import { render, staticRenderFns } from "./commSay.vue?vue&type=template&id=09fd67c7&scoped=true&"
import script from "./commSay.vue?vue&type=script&lang=js&"
export * from "./commSay.vue?vue&type=script&lang=js&"
import style0 from "./commSay.vue?vue&type=style&index=0&id=09fd67c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd67c7",
  null
  
)

export default component.exports